export abstract class ErrorBase extends Error {
  protected constructor(message: string, error: Error | string) {
    const isProduction = process.env.NODE_ENV === 'production'
    const msg = `${message} ${
      !isProduction ? (error instanceof Error ? error.message : error) : ''
    }`.trim()
    super(msg)
  }
}
